import { useContext, useEffect, ReactNode, DependencyList } from "react";
import { SidebarContext } from "./SidebarProvider";

export const useSidebar = () => useContext(SidebarContext);

export function useSidebarContent(content: ReactNode, deps: DependencyList) {
  const { setSidebar } = useSidebar();
  useEffect(() => {
    setSidebar(content);
    return () => setSidebar(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setSidebar, ...deps]);
}
